import VooksApplication2Days from '../../resources/images/vooks_application_2_days.png';
import VooksApplication31Days from '../../resources/images/vooks_application_31_days.png';
import VooksReview from '../../resources/images/vooks_review.gif';
import VooksOverview from '../../resources/images/vooks_overview.png';
import { useEffect, useState } from 'react';
import { checkPhoneNumber, setOnlyNumbers } from '../../utils/validationUtils';
import PersonalInformation from './PersonalInformation';
import VooksApplicationModal from './VooksApplicationModal';
import VooksApplicationResultModal from './VooksApplicationResultModal';
import VooksFavicon from '../../resources/favicons/vooks_favicon.ico';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCookie } from '../../utils/cookieUtils';
import { countUpAsync, initAsync } from '../../store/slices/vooksCountdownSlice';
import { ADVERTISEMENT_INFO, INFLUENCER_INFO } from '../../network/Endpoint';

const Vooks = () => {
  const [showApplicationModal, setShowApplicationModal] = useState(false);
  const [showApplicationResultModal, setShowApplicationResultModal] = useState(false);
  const [showPersonalInformationModal, setShowPersonalInformationModal] = useState(false);
  const [checked, setChecked] = useState(false);
  const [formData, setFormData] = useState({
    phoneNumber: '',
    applicationType: '',
    code: '',
  });
  const [message, setMessage] = useState();
  const [searchParams] = useSearchParams();
  const [info, setInfo] = useState({});
  const [isInfo, setIsInfo] = useState(false);
  const navigate = useNavigate();
  const vooksCountdownReducer = useSelector((state) => state.vooksCountdown);
  const dispatch = useDispatch();

  // usagePeriod 파라미터 가져오기.
  const usagePeriodParam = searchParams.get('usagePeriod') || '2';

  useEffect(() => {
    // cookie가 undefined거나 빈 객체일 때 초기화
    const countdownCookie = getCookie('vooksCountdown');
    if (countdownCookie === undefined || (Object.keys(countdownCookie).length === 0 && countdownCookie.constructor === Object)) {
      dispatch(initAsync());
    }
    randomCountUp();
  }, [navigate]);

  const randomCountUp = () => {
    if (vooksCountdownReducer.count < 95) { // count가 95 미만일 때에는 실행
      if (Math.random() < 0.5) { // 50% 미만 실행
        // 난수 생성
        let randomNumber = 0;

        // 생성한 난수와 카운트를 더한 값이 95 이하일 때 실행
        while (true) {
          // Math.floor(Math.random() * (max - min + 1)) + min
          // 1~10 사이의 난수 생성
          randomNumber = Math.floor(Math.random() * (10 - 1 + 1)) + 1;
          if (randomNumber + vooksCountdownReducer.count <= 95) {
            break;
          }
        }
        const body = {
          randomNumber: randomNumber
        };
        dispatch(countUpAsync(body));
      }
    }
  };

  const openApplicationModal = () => {
    setShowApplicationModal(true);
  };

  const closeApplicationModal = () => {
    setShowApplicationModal(false);
  };

  const openApplicationResultModal = (e) => {
    setMessage(e);
    setShowApplicationResultModal(true);
  };

  const closeApplicationResultModal = () => {
    setShowApplicationResultModal(false);
  };

  const handleFormData = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const openPersonalInformationModal = (data) => {
    setShowPersonalInformationModal(true);
  };

  const closePersonalInformationModal = () => {
    setShowPersonalInformationModal(false);
  };

  const openModal = () => {
    // isActive가 false인 경우 alert 띄우고 return
    if (info.isActive === false) {
      alert(info.inactiveReason);
      return;
    }
    // if (usagePeriodParam === '2') {
    //   // alert('현재 북스 2일 체험권 오류 발생으로 인하여 잠시, 사전 체험 신청 페이지를 중단합니다. 이용에 불편을 드려 죄송합니다.')
    //   alert('현재 북스 2일 체험권 신청이 마감되었습니다. 감사합니다.')
    //   return
    // }

    if (!checked) {
      alert('개인정보 수집 및 이용동의을 확인하고 동의하신다면 체크해 주세요.');
      return;
    } else if (formData.phoneNumber === '') {
      alert('폰 번호를 입력해 주세요.');
      return;
    } else if (!checkPhoneNumber(setOnlyNumbers(formData.phoneNumber))) {
      alert('폰 번호 형식을 확인해 주세요.');
      return;
    }
    openApplicationModal();
  };

  const handleCheck = (e) => {
    if (e.target.checked) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  };

  useEffect(() => {
    if (showApplicationModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showApplicationModal]);

  useEffect(() => {
    if (showApplicationResultModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showApplicationResultModal]);

  useEffect(() => {
    if (showPersonalInformationModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showPersonalInformationModal]);

  const backgroundStyle = {
    background: 'linear-gradient(#145d8d, #182365)'
  };

  const getInfluencerInfo = async (body) => {
    await INFLUENCER_INFO(body)
      .then(async (res) => {
        if (res.data.statusResponse.code === 'M0001') { // 성공
          setIsInfo(true);
          setInfo(res.data.influencer);
          // isActive가 false인 경우 alert 띄우기
          if (res.data.influencer.isActive === false) {
            alert(res.data.influencer.inactiveReason);
          }
        } else {
          setIsInfo(false);
        }
      })
      .catch(async (error) => {
        console.log('INFLUENCER_INFO error: ', error);
      });
  };

  const getAdvertisementInfo = async (body) => {
    await ADVERTISEMENT_INFO(body)
      .then(async (res) => {
        if (res.data.statusResponse.code === 'M0001') { // 성공
          if (res.data.advertisement.title !== '') {
            setIsInfo(true);
            setInfo(res.data.advertisement);
            // isActive가 false인 경우 alert 띄우기
            if (res.data.advertisement.isActive === false) {
              alert(res.data.advertisement.inactiveReason);
            }
          } else {
            setIsInfo(false);
          }
        } else {
          setIsInfo(false);
        }
      })
      .catch(async (error) => {
        console.log('ADVERTISEMENT_INFO error: ', error);
      });
  };

  useEffect(() => {
    let applicationType = searchParams.get('application_type');
    let code = searchParams.get('code');
    if (applicationType && code) {
      setFormData({
        ...formData,
        applicationType: applicationType,
        code: code,
      });
      if (applicationType === 'INFLUENCER') { // 인플루언서
        const body = {
          code: code
        };
        getInfluencerInfo(body);
      } else if (applicationType === 'ADVERTISEMENT') { // 광고
        const body = {
          code: code
        };
        getAdvertisementInfo(body);
      }
    }
  }, []);

  // useEffect(() => {
  //   if (usagePeriodParam === '2') {
  //     // alert('현재 북스 2일 체험권 오류 발생으로 인하여 잠시, 사전 체험 신청 페이지를 중단합니다. 이용에 불편을 드려 죄송합니다.')
  //     alert('현재 북스 2일 체험권 신청이 마감되었습니다. 감사합니다.')
  //   }
  // }, [])

  return (
    <div className={'flex justify-center'}>
      <Helmet>
        <title>Vooks</title>
        <link rel={'icon'} href={VooksFavicon}/>
      </Helmet>
      <VooksApplicationModal showApplicationModal={showApplicationModal}
                             closeApplicationModal={closeApplicationModal}
                             parentFormData={formData}
                             parentUsagePeriodParam={usagePeriodParam}
                             openApplicationResultModal={openApplicationResultModal}
                             randomCountUp={randomCountUp}/>
      <VooksApplicationResultModal showApplicationResultModal={showApplicationResultModal} closeApplicationResultModal={closeApplicationResultModal} message={message}/>
      <PersonalInformation showPersonalInformationModal={showPersonalInformationModal} closePersonalInformationModal={closePersonalInformationModal}/>
      <div className={'max-w-[500px]'}>
        {
          isInfo ? (
            <div className={'font-[kohi-baeum]'}>
              <div className={'flex justify-center items-center h-[80px] bg-[#32329d] text-[20px] text-[#ffffff]'}>
                {info.title}
              </div>
              <div className={'flex justify-center items-center h-[60px] bg-gradient-to-r from-[#4A55EF] to-[#5070FA]'}>
                <div className={'flex justify-center items-center w-[200px] h-[40px] bg-[#ffff80] text-[#32329d] rounded-full'}>
                  선착순: {vooksCountdownReducer.count}/100명
                </div>
              </div>
            </div>
          ) : null
        }
        {usagePeriodParam === '31' ? (<img src={VooksApplication31Days} alt={'VooksApplication31Days'}/>) : (<img src={VooksApplication2Days} alt={'VooksApplication2Days'}/>)}
        <div style={backgroundStyle}>
          <div className={'flex justify-center pt-[20px]'}>
            <input type={'text'}
                   name={'phoneNumber'}
                   value={formData.phoneNumber || ''}
                   onChange={handleFormData}
                   className={'w-[300px] border-[2px] border-[#1a1f41] rounded-[10px] h-[60px] text-center font-[nanum-square-b] text-[24px]'} placeholder={'010-0000-0000'}/>
          </div>
          <div className={'flex justify-center font-[nanum-square-b] mt-[20px]'}>
            <div className={'text-[#ebf4fc] flex items-center'}>
              <input type={'checkbox'} id={'checked'} checked={checked} onChange={(e) => handleCheck(e)} className={'flex items-center w-[18px] h-[18px] accent-[#00ff00]'}/>
              <label htmlFor={'checked'}>
                <div className={'ml-[6px]'}>개인정보 수집 및 이용동의(필수)</div>
              </label>
            </div>
            <button type={'button'} onClick={openPersonalInformationModal} className={'flex items-center text-[#cccccc] underline underline-offset-4 decoration-2 text-[12px] ml-[10px]'}>상세보기
            </button>
          </div>
          <div className={'flex justify-center mt-[20px]'}>
            <button type={'button'}
                    onClick={openModal}
                    className={'border border-[#ffe67d] bg-[#ffe67d] text-[#1a1f41] font-[nanum-square-round-eb] text-[24px] w-[260px] h-[60px] rounded-[10px]'}>
              신청 하기
            </button>
          </div>
          <div className={'flex justify-center font-[nanum-square-b] text-[14px] mt-[30px] pb-[20px] text-[#7f9cb2]'}>
            {usagePeriodParam === '2' ? (
              <div>* 북스 무료 체험권은 60일마다 신청이 가능합니다.</div>
            ) : usagePeriodParam === '31' ? (
                <div>* 북스 무료 체험권은 1년마다 신청이 가능합니다.</div>
              )
              : null}
          </div>
        </div>
        <img src={VooksReview} alt={'VooksReview'}/>
        <img src={VooksOverview} alt={'VooksOverview'}/>
      </div>
    </div>
  );
};

export default Vooks;
